module.exports = __webpack_public_path__ + "media/src/assets/images/loading-468b8b4cb01a50c8f7954ccfcb41c854.gif";